import { AssetTypeType } from "@intelligems/ig-types/schemas/organization";
import {
  GetAssetsRequestPathParamType,
  GetAssetsRequestQueryParamType,
  GetAssetsResponseBodyType,
} from "@intelligems/ig-types/functions/shopify-themes/get-theme-assets";
import { QueryObserverOptions, useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationThemeAssetsKey } from "../queryKeys";
import { ApiRequest } from "../types/api";

const getThemeAssets = async (
  payload: ApiRequest<
    any,
    GetAssetsRequestPathParamType,
    GetAssetsRequestQueryParamType
  >
) => {
  const resp = await api.get<GetAssetsResponseBodyType>(
    `/v2/organizations/theme/${payload.pathParams.themeId}/assets`,
    {
      params: payload.queryParams,
    }
  );
  return resp.data;
};

export const useThemeAssets = (
  assetType: AssetTypeType,
  themeId?: string,
  options?: QueryObserverOptions<GetAssetsResponseBodyType, Error>
) => {
  const org = useGetOrg();
  return useQuery<GetAssetsResponseBodyType, Error>({
    queryKey: organizationThemeAssetsKey.one(
      org.data.org.id,
      themeId!,
      assetType
    ),
    queryFn: async () =>
      getThemeAssets({
        body: undefined,
        pathParams: { themeId: themeId! },
        queryParams: { assetType },
      }),
    enabled: !!themeId,
    ...options,
  });
};
